import React, { FC } from 'react';
import styled from 'styled-components';

import { useUrlBuilder } from 'hooks/useUrlBuilder';

const StyledWarningIcon = styled.img`
  height: 20px;
  width: 20px;
`;

export const WarningIcon: FC = () => {
  const { withCDN } = useUrlBuilder();
  return <StyledWarningIcon src={withCDN('misc/warning-symbol.jpg')} />;
};
